var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.75 12.5L15 18.75L21.25 12.5L8.75 12.5Z","fill":"currentColor"}));
}

ArrowDown.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
